import { render } from "./AddHolidays.vue?vue&type=template&id=46a8c338"
import script from "./AddHolidays.vue?vue&type=script&lang=js"
export * from "./AddHolidays.vue?vue&type=script&lang=js"

import "./AddHolidays.vue?vue&type=style&index=0&id=46a8c338&lang=scss"

import exportComponent from "/home/douglas/Documents/Rwi/surefooted-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__